import { Fragment } from "react/jsx-runtime";
import { SectionHeading } from "~/components/DetailsPage/components/SectionHeading";
import { Link as RouterLink } from "react-router-dom";
import { Button, Grid, Link } from "@mui/material";
import {
  ArrowForward as ArrowForwardIcon,
  OpenInNew as OpenInNewIcon,
} from "@mui/icons-material";
import { useAssetInsights } from "../../hooks";
import AssetInsightsTable from "~/pages/findings/FindingOnAsset/components/AssetInsights/AssetInsightsTable";
import AssetInsightsSectionHeading from "~/pages/findings/FindingOnAsset/components/AssetInsights/AssetInsightsSectionHeading";
import { Flex } from "~/components/Flex";

export function AssetInsights() {
  const {
    evidenceGroup,
    platformGroup,
    linkToAsset,
    assetOverviewGroupItemsLinks,
  } = useAssetInsights();

  return (
    <Fragment>
      <SectionHeading
        heading="Asset insights"
        {...(linkToAsset && {
          dividerContent: (
            <Button
              component={RouterLink}
              to={linkToAsset}
              endIcon={<ArrowForwardIcon />}
              sx={{ color: "secondary.light" }}
            >
              Go to asset
            </Button>
          ),
        })}
      />
      <Grid
        container
        size={12}
        rowSpacing={4}
        columnSpacing={10}
        justifyContent="space-between"
      >
        <Grid size={{ xs: 12, md: 6 }}>
          <AssetInsightsSectionHeading title="Asset Details" />
          {platformGroup && <AssetInsightsTable group={platformGroup} />}
        </Grid>
        {/* <Grid size={{ xs: 12, md: "auto" }}>
          <AssetInsightsSectionHeading title="Users & Sessions" />
          <AssetInsightsTable />
        </Grid> */}
        {/* <Grid size={{ xs: 12, md: "auto" }}>
          <AssetInsightsSectionHeading title="Listening Services" />
          <AssetInsightsTable />
        </Grid> */}
        {/* <Grid size={12}>
          <AssetInsightsSectionHeading title="Lateral Movement Risk" />
          <Stack
            direction="row"
            alignItems="center"
            mt={3}
            columnGap={4}
            rowGap={2}
            flexWrap="wrap"
          >
            {Array.from({ length: 3 }).map((_, i) => {
              return (
                <Stack direction="row" gap={2} key={i} sx={{ width: 264 }}>
                  <EKSClustersIcon sx={{ fontSize: 40, borderRadius: 1 }} />
                  <Stack direction="column">
                    <Typography sx={{ fontWeight: 700 }}>
                      EKS Account
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: 12,
                        color: "text.secondary",
                        textTransform: "uppercase",
                        lineHeight: "16px",
                      }}
                    >
                      1 discovered
                    </Typography>
                  </Stack>
                </Stack>
              );
            })}
          </Stack>
        </Grid> */}
      </Grid>
      <Flex sx={{ flexDirection: "column" }}>
        {assetOverviewGroupItemsLinks?.map((item, index) =>
          item ? (
            <Link
              key={`${item.key}-${index}`}
              color="primary"
              component={RouterLink}
              to={item.link}
              target="_blank"
              sx={{
                mt: 1,
                textTransform: "uppercase",
                display: "inline-flex",
                alignItems: "center",
                gap: 0.5,
                textDecoration: "none",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
            >
              {item.name}
              <OpenInNewIcon fontSize="small" />
            </Link>
          ) : null,
        )}
      </Flex>
    </Fragment>
  );
}
